<template>
<div>
    <div class="title">
    <span class="link">应用管理
       ></span> <span class="curLink">
         {{ menuTab[activeMenu].name }}
    </span>   
   </div>
   <div class="tabList">
        <div class="tab" v-for="(item, index) in menuTab" :key="index" @click="topTabMenu(item, index)"
          :class="{'activeIndex': activeMenu == index}">
          {{item.name}}
        </div>
    </div>
   <div class="content">
     <div class="pageList">
       <template v-if="activeMenu === 0">
         <AuthorizedApp/>
       </template>
       <template v-else-if="activeMenu === 1">
          <AppMarket />
       </template>
     </div>
   </div>
</div>    
</template>
<script>
import AuthorizedApp from './components/AuthorizedApp.vue'
import AppMarket from './components/AppMarket.vue'
export default {
    data() {
      return {
        menuTab: [
          {
              name: '授权应用'
          },
          {
              name: '应用市场'
          },
        ],
        activeMenu: 0,
      }
    },
    created() {
    },
    components:{
      AuthorizedApp,
      AppMarket,
    },
    methods: {


      topTabMenu(item, index) {
        this.activeMenu = index
      },
    }
}
</script>

<style scoped>
.title {
    height: 66px;
    line-height: 66px;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #282F3D;
    padding-left: 30px;
    background: #fff;
  }
  .curLink{
    cursor: pointer;
  }
  .link{
    color: rgba(144, 157, 177, 1);
  }
  .tabList {
    height: 42px;
    /* display: flex; */
    /* justify-content: flex-start; */
    padding-right: 20px;
    /* border-bottom: 1px solid #909DB1; */
    padding: 0 20px 0;
  }

  .tabList>div.tab {
    cursor: pointer;
    width: 100px;
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #909DB1;
    text-align: center;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    /* border-bottom: 2px solid transparent; */
  }
  .tabList>div.tab.activeIndex {
    border-bottom: 2px solid #225EFD;
    color: #225EFD;
  }

  .content {
    box-sizing: border-box;
    padding: 0px 20px;
    position: relative;
  }

  .pageList {
    width: 100%;
    height: calc(100vh - 230px);
    background: #FFFFFF;
    box-shadow: 1px 3px 16px 0px rgba(204, 211, 228, 0.51);
    border-radius: 8px;
    box-sizing: border-box;
    padding: 0px 40px;
    /* border: 1px solid #f00; */
  }
  /* ::-webkit-scrollbar { width: 0 !important } */
  
</style>


// WEBPACK FOOTER //
// src/views/console/AppMarket.vue